<template>
  <div class="highlighted-cards">
    <div v-if="session" class="highlighted-card">
      <router-link
        :to="sessionRoute"
        :class="['link', clickable ? 'disabledRouter' : '']"
        @click.native="trackSessionCard"
      >
        <div
          class="session-card"
          no-body
        >
          <div
            :style="[{'border-left': borderleft}, {'background-color':showSessionColor ? cardStyles : ''}]"
            class="session-card__body"
          >
            <div
              class="session-card__title">
              <span class="session-card__title-number" v-html="session.Number"></span>
              <span v-html="session.Name"></span>
            </div>
           <div class="session-card__roomcontainer">
            <font-awesome-icon :icon="['fas', 'map-marker']" /> 
            <span
              class="session-card__sub-title"
              v-html="session.RoomName"
            />
           </div>
                    
            <div
              class="session-card__sub-title"
            >
              {{ formatDayTitle(session.StartDateTime, "dddd, DD MMMM YYYY") }} | {{ formatDateTime(session.StartDateTime) }} - {{ formatDateTime(session.EndDateTime) }}
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div v-if="presentation" class="highlighted-card">
      <router-link
        :to="presentationRoute"
        class="link"
        @click.native="trackPresentationCard"
      >
        <div
          class="session-card"
          no-body
        >
          <div
            class="session-card__body"
            :style="[{'border-left': borderleft}, {'background-color':showPresentationColor ? presentationCardStyles : ''}]"
          >
            <div
              class="session-card__"

              v-if="presentation.Number"
            >
              <span v-if="presentation.Number">{{ presentation.IsPoster? $t('AppTranslations.PosterID') : $t('AppTranslations.PresentationID') }} {{ presentation.Number }} </span>
              <span v-if="showAbstractNumber"> - </span>
              <span v-if="showAbstractNumber">{{ $t('AppTranslations.FPNNumber') }} {{ presentation.AbstractNumber }} </span>
            </div>
            <div
              class="session-card__title"

              v-html="presentation.Title"
            />
            <div
              class="__highlight-presentation-tags"
              v-if="presentation.PresentationTags"
            >
              <span
                class="__tags"
                v-for="(tags, idx) in presentation.PresentationTags"
                :key="idx"
                v-html="tags"
              />
            </div>
            <div

            >
              <span v-if="presentation.SpeakerFirstname">{{ presentation.SpeakerFirstname }} </span>
              <span v-if="presentation.SpeakerSurname">{{ presentation.SpeakerSurname }} </span>
              <span v-if="presentation.SpeakerCity && presentation.SpeakerCountry">(</span>
              <span v-if="presentation.SpeakerCity">{{ presentation.SpeakerCity }}</span>
              <span v-if="presentation.SpeakerCity && presentation.SpeakerCountry">, </span>
              <span v-if="presentation.SpeakerCountry">{{ presentation.SpeakerCountry }}</span>
              <span v-if="presentation.SpeakerCity && presentation.SpeakerCountry">)</span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div v-if="author" class="highlighted-card">
      <router-link
        :to="authorRoute"
        class="link"
        @click.native="trackAuthorCard"
      >
        <div
          class="author-card"
          no-body
        >
          <div
            class="author-card__body"
          >
            <img class="author-card__content-profile-image" v-lazy="author.ProfileUrl" />

            <div class="author-card__text_body">
              <div
                class="author-card__title"

                v-html="author.TitleFirstnameSurname"
              />
              <div

              >
                <span v-if="author.City">{{ author.City }}</span>
                <span v-if="author.City && author.Country">, </span>
                <span v-if="author.Country">{{ author.Country }}</span>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import utils from '../utilities'
import trackingApi from '~/api/tracking'

import dateMixins from '../mixins/dateMixins'

export default {
  props: {
    session: {
      type: Object,
      default: () => {},
    },
    presentation: {
      type: Object,
      default: () => {},
    },
    author: {
      type: Object,
      default: () => {},
    },
    showAbstractNumber: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    showPresentationColor: {
      type: Boolean,
      default: false,
    },
    showSessionColor: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [dateMixins],
  data() {
    return {
      borderleft: this.session ? `5px solid ${this.session.Color}` : '',
      name: this.$route.name,
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/configForKey',
    }),
    cardStyles() {
      return `${this.hexToRgbA(this.session.Color)}`
    },
    presentationCardStyles() {
      const eventShort = this.$store.getters['instancesState/getEvent']
      if(this.presentation?.Color) {
        return `${this.hexToRgbA(this.presentation.Color)}`
      }

      if (eventShort === 'ean2023' && this.presentation?.PresentationTypeName === 'epresentation') {
        return `${this.hexToRgbA('#CCDCF5')}`
      }

      if (eventShort === 'ean2023' && this.presentation?.PresentationTypeName === 'eposter') {
        return `${this.hexToRgbA('#00ABFF')}`
      }
      return ''
    },
    appConfigV2() {
      const appConfigV2 = this.config('app_config')
      if (appConfigV2.configV2) {
        return appConfigV2.configV2
      }
      return null
    },
    sessionRoute() {
      const route = this.appConfigV2?.defaultV2?.routeV2
        ? { name: 'PagSessionDetailPage', params: { sessionId: this.session.Id } }
        : { name: 'ProgramPage', query: { sessionwithheader: this.session.Id } }
      return utils.appendDefaultParamsToRoute(route)
    },
    presentationRoute() {
      const route = this.appConfigV2?.defaultV2?.routeV2
        ? { name: 'PagPresentationDetailPage', params: { presentationId: this.presentation.Id } }
        : { name: 'ProgramPage', query: { presentation: this.presentation.Id } }
      return utils.appendDefaultParamsToRoute(route)
    },
    authorRoute() {
      const route = this.appConfigV2?.defaultV2?.routeV2
        ? { name: 'PagFacultyDetailPage', params: { userId: this.author.UserId } }
        : { name: 'ProgramPage', query: { user: this.author.UserId } }
      return utils.appendDefaultParamsToRoute(route)
    },
  },
  methods: {
    hexToRgbA(hex) {
      if (hex) {
        let c
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
          c = hex.substring(1)
            .split('')
          if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
          }
          c = `0x${c.join('')}`
          return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},0.35)`
        }
        throw new Error('Bad Hex')
      }
      return ''
    },
    async trackSessionCard() {
      trackingApi.trackCustomAction('vmx-program-card-session', this.session.Id, this.name)
    },
    async trackPresentationCard() {
      trackingApi.trackCustomAction('vmx-program-card-presentation', this.presentation.Id, this.name)
    },
    async trackAuthorCard() {
      trackingApi.trackCustomAction('vmx-program-card-speaker', this.author.UserId, this.name)
    },
  },
}
</script>

<style lang="scss">

.disabledRouter {
  pointer-events: none;
}
.highlighted-cards{
  height: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background: #fff;
.highlighted-card {
  height: 100% !important;
}
.session-card {
  height: 100% !important;
  > *  {
    height: 100% !important;
  }
}

.session-card {

  .session-card__body{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1rem;
    gap: 0.5rem;
  }
  .session-card__title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-weight: bold;
    margin: 0;
    .session-card__title-number {
      margin-right: .5rem;
    }
  }

  .session-card__roomcontainer {
    display: flex;
    gap: 0.5rem;
    color: #000;
    align-items: center; 
    .session-card__sub-title {
     color: #000;
    }
  }

  .session-card__content-profile-image {
    object-fit: cover;
    height: 100px;
    width: 100px;
    border-radius: 50%;
    border: solid 3px var(--primary);
  }
}

 .__highlight-presentation-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  .__tags {
    border: solid 1px var(--primary);
    color: var(--primary);
    background: #fff;
    display: inline-block;
    border-radius: 0.25rem;
    font-size: 0.75rem;
    line-height: 1.5;
    padding: 0.125rem 0.25rem;
    text-align: center;
    vertical-align: middle;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .__tags:hover {
    white-space: normal;
    overflow: unset;
  }
  > span.__tags {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 50ch;
  }
}

 .__presentation-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  .__tags {
    border: solid 1px var(--pag-primary);
    color: var(--pag-primary);
    display: inline-block;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
    padding: 0.2rem 0.7rem;
    text-align: center;
    vertical-align: middle;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .__tags:hover {
    white-space: normal;
    overflow: unset;
  }
  > span.__tags {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 50ch;
  }
}

.author-card {
  .author-card__body{
    color: #000;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .author-card__text_body {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
  }
  .author-card__title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .author-card__content-profile-image {
    object-fit: cover;
    height: 100px;
    width: 100px;
    border-radius: 50%;
    border: solid 3px var(--primary)
  }
}
}
</style>
